module.exports = __webpack_public_path__ + "static/assets/a2c79f5dd29adbc7d3d71d179fd566b1.svg";